import { render, staticRenderFns } from "./PlanChangeButton.vue?vue&type=template&id=2855aaa7&"
import script from "./PlanChangeButton.vue?vue&type=script&lang=js&"
export * from "./PlanChangeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports